import { render } from "./ContentModeration.vue?vue&type=template&id=ee44f2bc"
import script from "./ContentModeration.vue?vue&type=script&lang=js"
export * from "./ContentModeration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__